import axios from "@/config/axios";

const initialState = () => {
  return {
    logs: []
  }
};

const state = initialState();


const getters = {
  getAllLogs: state => state.logs,
};

const mutations = {
  setAllLogs(state, logs) {
    state.logs = logs
  },
  reset: state => {
    const initial = initialState();
    Object.keys(initial).forEach(key => {
      state[key] = initial[key];
    });
  }
};

const actions = {
  fetchAllLogs: async ({commit,dispatch},params ) => {
    try {
     await dispatch("errors/clear", [], { root: true });

     const response = await axios.get("/audit-logs", { params });
  
      commit("setAllLogs", response.data);
    }
    catch (error) {
      if (error.response) {
      await dispatch("errors/errorResponse", error.response, { root: true });
      }
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
